module.exports = __webpack_public_path__ + "static/img/service.62692df1.png";